var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEkata = function SvgEkata(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.45 3.59578V6.87789C19.45 7.20693 19.1833 7.47368 18.8542 7.47368H9.94015C9.6111 7.47368 9.34435 7.74043 9.34435 8.06946V16.0884C9.34435 16.4175 9.6111 16.6842 9.94016 16.6842H18.8542C19.1833 16.6842 19.45 16.951 19.45 17.28V20.4042C19.45 20.7332 19.1833 21 18.8542 21H5.1505C4.82144 21 4.55469 20.7332 4.55469 20.4042V3.59578C4.55469 3.26675 4.82144 3 5.1505 3H18.8542C19.1833 3 19.45 3.26675 19.45 3.59578ZM10.8164 10.754V13.194C10.8164 13.5231 11.0831 13.7898 11.4123 13.7898H16.9577C17.2867 13.7898 17.5535 13.5231 17.5535 13.194V10.754C17.5535 10.4249 17.2867 10.1582 16.9577 10.1582H11.4123C11.0831 10.1582 10.8164 10.4249 10.8164 10.754Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEkata);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ekata.d13c07bf92035bf698d4f4100768f873.svg";